// src/pages/message-center/utils/phaseProgressColor.js

// target-vs-achieved: higher = better, so bands read the opposite way from a "usage" meter
export const getProgressPercentage = (achieved, target) => {
  if (target == null || target <= 0) {
    return null;
  }
  const value = (parseFloat(achieved) || 0) / target * 100;
  return Math.min(100, Math.max(0, value));
};

export const getProgressColorClass = (percentage) => {
  if (percentage == null) {
    return 'neutral';
  }
  if (percentage < 40) {
    return 'red';
  }
  if (percentage < 75) {
    return 'yellow';
  }
  return 'green';
};
